export interface GlobalUploadNameTemplate {
  label: string;
  value: string;
}

/** Dateinamen-Vorschläge wie in `frontend/static/partials/header.js`. */
export const GLOBAL_UPLOAD_NAME_TEMPLATES: GlobalUploadNameTemplate[] = [
  { label: "Standard", value: "{{Projektnr.}}-{{Dokumentenname}}.pdf" },
  { label: "Angebot", value: "{{Projektnr.}}-Angebot.pdf" },
  {
    label: "Lieferanten-LS",
    value: "{{Projektnr.}}-Lieferanten-LS-{{Dokumentenname}}.pdf",
  },
  {
    label: "Lieferanten-RE",
    value: "{{Projektnr.}}-Lieferanten-RE-{{Dokumentenname}}.pdf",
  },
  {
    label: "Lieferanten-ANG",
    value: "{{Projektnr.}}-Lieferanten-ANG-{{Dokumentenname}}.pdf",
  },
  {
    label: "Kunden-BEST",
    value: "{{Projektnr.}}-Kunden-BEST-{{Dokumentenname}}.pdf",
  },
  { label: "Kurier", value: "{{Projektnr.}}-Kurier.pdf" },
  { label: "Sonstiges", value: "{{Projektnr.}}-Sonstiges.pdf" },
];

/** Markierung als Schadensmeldung / FM-Auftrag (wie Beauftragung, für Monteure einsehbar). */
export const SCHADENSMELDUNG_NAME_TEMPLATE: GlobalUploadNameTemplate = {
  label: "Schadensmeldung / FM-Auftrag",
  value: "{{Projektnr.}}-Schadensmeldung.pdf",
};

export interface GlobalUploadFileEntry {
  id: string;
  original: File;
  customName: string;
  hasConflict: boolean;
  /** Datei als Schadensmeldung / FM-Auftrag markieren (Beauftragung-ähnlich). */
  asSchadensmeldung?: boolean;
}

export interface GlobalUploadUploadEntry {
  fileIndex: number;
  auftragId: number;
  entry: GlobalUploadFileEntry;
}
